<template>
    <div>
        <v-cookie></v-cookie>
        <div class="place">
            <span>位置：</span>
            <ul class="placeul">
                <li><a href="#">首页</a></li>
                <li>短信</li>
                <li><a href="#">短信库管理</a></li>
            </ul>
        </div>    
        <div class="formbody">    
            <div class="formtitle"><span>短信库管理</span></div>    
            <ul class="forminfo">    
                <li style="padding-top:15px;">
                    <div class="groupings_l30">短信类别名称</div><div class="groupings_l30">条 数</div>
                    <div class="groupings_l30">
                        操作
                    </div>
                </li>    
                <div class="xline"></div>    
                <template v-for="item in smsClassFiyList">
                    <li style="padding-top:15px;">
                        <div class="groupings_l30"><a href="#" @click="gotoSmsContent(item.id,item.typename,item.userid)">{{item.typename}}</a></div>
                        <div class="groupings_l30">{{item.smscontentcount}}</div>
                        <div class="groupings_l30">
                            <ol v-if="item.userid != null && item.userid.trim() != ''">
                            <a href="#" @click="editSmsClassFiy(item.id,item.typename)">编辑</a> 
                            &nbsp;&nbsp;  <a href="#" @click="delSmsClassFiy(item.id)">删除</a>
                            </ol>
                            <ol v-else>--&nbsp;&nbsp;--</ol>
                        </div>
                    </li>    
                    <div class="xline"></div>
                </template>
    
                <li style="padding-top:15px;">
                    <div class="groupings_l30"> &nbsp; </div>
                    <div class="groupings_l30"> &nbsp; </div>
                    <div class="groupings_l30">    
                        <ul class="toolbars">
                            <li class="click" @click="addSmsClassFiy()">添加分组</li>
                        </ul>   
                    </div>
                </li>    
            </ul>    
        </div>
        <!-- tip 编辑-->
        <div class="tip tip1" style="height:250px;">
    	    <div class="tiptop"><span>短信库类别修改</span><a></a></div>        
            <div class="tipinfo" style="height:80px;">
                类别名称：<input name="" v-model="typename" type="text" class="scinput" style="width:280px;"/>
            </div>        
            <div class="tipbtn">
                <input name="" type="button" @click="updSmsClassFiy()"  class="sure" value="确定" />&nbsp;
                <input name="" type="button"  class="cancel" @click="close()" value="取消" />
            </div>    
        </div> 

        <!-- tip 编辑-->
        <div class="tip tip2" style="height:250px;">
    	    <div class="tiptop"><span>添加短信库类别</span><a></a></div>        
            <div class="tipinfo" style="height:80px;">
                类别名称：<input name="" v-model="typename" type="text" class="scinput" style="width:280px;"/>
            </div>        
            <div class="tipbtn">
                <input name="" type="button" @click="saveSmsClassFiy()"  class="sure" value="确定" />&nbsp;
                <input name="" type="button"  class="cancel" @click="close2()" value="取消" />
            </div>    
        </div> 
    </div>
</template>
<script>
import cookie from '@/components/cookie.vue'
export default {
    components : {
        'v-cookie' : cookie,
    },
    data(){
        return{
            smsClassFiyList:[],
            id:-1,
            typename:'',
        }
    },
    mounted(){
        this.getData();
    },
    methods:{        
        getData(){
            let that = this;
            let data = {};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/sms/smsclassfiy.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.smsClassFiyList = res.data.smsClassFiyList;
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        getCount(id){
            let that = this;
            var rowcount = 0;
            let data = {'id':id};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/sms/getsmsclassfiycount.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    rowcount = res.data.count;                    
                }
                else
                {
                    
                }
            })
            return rowcount;
        },
        gotoSmsContent(id,typename,userid){
            if(userid == null || userid.trim() == '')
                location.href = "/smsclassfiycontent?id="+id+"&typename="+typename+"&e=0";
            else
                location.href = "/smsclassfiycontent?id="+id+"&typename="+typename+"&e=1";
        },
        editSmsClassFiy(id,typename){
            // alert(id+","+typename);
            $(".tip1").fadeIn(200);
            $(".tiptop a").click(function(){
                $(".tip1").fadeOut(200);
            })
            this.typename = typename;
            this.id = id;
        },
        updSmsClassFiy(){
            if(this.typename.trim() == ''){
                alert("类别名称不能为空！");
                return;
            }
            let that = this;
            let data = {'id':this.id,'typename':this.typename};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/sms/updsmsclassfiy.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    alert("修改成功！");
                    that.close();
                    that.getData();
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        close(){
            $(".tip1").fadeOut(200);
        },
        addSmsClassFiy(){
            $(".tip2").fadeIn(200);
            $(".tiptop a").click(function(){
                $(".tip2").fadeOut(200);
            })
            $('body,html').animate({scrollTop:0},10);
            this.id = '';
            this.typename = '';
            
        },
        close2(){
            $(".tip2").fadeOut(200);
        },
        saveSmsClassFiy(){
            if(this.typename.trim() == ''){
                alert("类别名称不能为空！");
                return;
            }
            if(this.typename.trim().length > 50){
                alert("类别名称长度不能超过50！");
                return;
            }
            let that = this;
            let data = {'typename':this.typename};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/sms/insertsmsclassfiy.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    alert("添加成功！");
                    that.close2();
                    that.getData();
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        delSmsClassFiy(id){
            if(confirm("确定需要删除这个分类吗？删除后，此分类下所有的短信也会被删除！")){
                let that = this;
                let data = {'id':id};
                this.$ajax({
                    method: 'post',
                    url: this.GLOBAL.serverSrc + '/sms/delsmsclassfiy.json',
                    data: data,
                    headers: {
                        'Content-Type': 'application/json; charset=UTF-8',
                        'token' : this.GLOBAL.token
                    }
                }).then(function(res) {
                    if('0000000' == res.data.code)
                    {
                        alert("删除成功！");
                        that.close2();
                        that.getData();
                    }
                    else
                    {
                        alert(res.data.msg)
                    }
                })
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/sms/smsclassfiy.vue